import React, { useEffect, useState } from "react";
import "./MultipleAssignment.css";
import { useNavigate } from "react-router";
import QuestionNew from "../../pages/home/components/questions/Question_new";
import MultipleAssignmentviewPopup from "./MultipleAssignmentviewPopup";
import StudentAssignmentScore from "../../pages/home/components/dashboard/student/lessons/StudentAssignmentScore";
import { createAssignmentStatus, resetcreateAssignStatus } from "../../state/actions/createAssignmentStatusAction"
import { useAuth } from "../../features/auth/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import Helper from "../../utils/Helper";
import { Tooltip } from "react-tooltip";
import CongratulationsPopup from '../../components/CongratulationsPopup/CongratulationsPopup';
import {
    check_image
} from "../../assets/images/images";
import { getAssignmentsByLesson } from "../../state/actions/getAssignmentsByLessonAction";

function MultipleAssignmentStartAssignment({ index, practiceassignment, lesson, course, rubrics, setcallWebSocket, callWebSocket, setwebsocketPayload, assignmentResultHandler, filteredAssignments }) {


    const navigate = useNavigate();
    const { token } = useAuth();
    const dispatch = useDispatch();
    const [detailedResult, setdetailedResult] = useState(false);
    const [assignmentIndex, setAssignmentIndex] = useState(0);
    const [arrayIndex, setArrayIndex] = useState(0);
    const [pracassignmentPopUp, setpracassignmentPopUp] = useState(false);
    const [showScorePopup, setshowScorePopup] = useState(false);
    const [mainRubric, setMainRubric] = useState(null);
    const courseType = course?.course_type


    const [showCongratulations, setShowCongratulations] = useState(false);

    const startAssignmentPopup = (rub_id) => {
        setpracassignmentPopUp(!pracassignmentPopUp)
        let rubricId = null
        if (rub_id !== null) {
            for (let i = 0; i < rubrics.length; i++) {
                if (rub_id === rubrics[i].rubric_id) {
                    rubricId = rubrics[i]
                    break;
                }
            }
        }

        setMainRubric(rubricId)

    }

    const assignmentJSON = practiceassignment?.assignment_json?.map((item) => {
        return { ...item, student_answer: null, time_taken: "0" };
    });

    useEffect(() => {
        // If either assignment_json or ai_feedback_json is null, trigger API call after 30 seconds
        if (!practiceassignment?.assignment_json || !practiceassignment?.ai_feedback_json) {
            const timer = setTimeout(() => {
                // Dispatch API to fetch updated assignments after 30 seconds
                dispatch(getAssignmentsByLesson(lesson?.lesson_id, 1, token, courseType)); // Fetch assignments using lesson_id
            }, 20000); // 20 seconds delay

            return () => clearTimeout(timer); // Cleanup the timeout if the component is unmounted
        }
    }, [practiceassignment?.assignment_json, practiceassignment?.ai_feedback_json, dispatch, lesson?.lesson_id]);


    useEffect(() => {
        if (showCongratulations) {
            setTimeout(() => {
                setShowCongratulations(false)
            }, 2000)
        }

    }, [showCongratulations])


    const globalState = useSelector((state) => state.globalState);
    // const practice_assignment_status = globalState.userCurrentPlan?.currentSubscription && globalState.userCurrentPlan.currentSubscription.plan_data.practice_assignment


    const enterFullscreen = () => {
        const elem = document.documentElement; // full page

        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
            elem.msRequestFullscreen();
        }
    };


    const startPractiseAssignmentHandler = (status = 3) => {

        if (practiceassignment?.course_type === 2) {
            enterFullscreen();
        }


        const course_id = course?.course_id;
        const lesson_id = lesson?.lesson_id;
        const id = practiceassignment?.id;


        const payload = {
            student_id: globalState.student_details.data.student_id,
            assignment_id: id,
            status: 3,
            completed_name: practiceassignment.name,
            assignment_type: 2,
        };

        dispatch(createAssignmentStatus(payload, token, courseType))

        try {
            const state = {
                course: JSON.parse(JSON.stringify(course)),
                lesson: JSON.parse(JSON.stringify(lesson)),
                assignment: practiceassignment,
                rubric: null,
                assignmentDtls: practiceassignment?.length > 0 ? JSON.parse(JSON.stringify(practiceassignment))
                    : null,
                type: 2,
            };
            navigate(
                // `/course/${course_id}/lesson/${lesson_id}/assignment/${practiceassignment.assignment_id}/preview`,
                `/course/${course_id}/lesson/${lesson_id}/assignment/${id}/preview`,
                { state }
            );
        } catch (error) {
            console.error("Serialization error:", error);
        }
    }

    return (
        <>
            <div className="maltiple-assignment-card">
                {/* <p className="maltiple-assignment-title practice-assignment-title"><span>{index + 1}.</span>Review Assignment </p> */}
                <p className="maltiple-assignment-title practice-assignment-title"><span>{index + 1}.</span>Practice Assignment </p>
                <div className="maltiple-assignment-card-date-container">
                    <div className="maltiple-assignment-card-date">
                        <p>Created On: </p>
                        <p>{Helper.formatDateTime(practiceassignment?.created_at).date}</p>
                    </div>
                    <div className="maltiple-assignment-card-date">
                        {practiceassignment?.submission === null ? (
                            <>
                            </>
                        ) : (
                            <>
                                <p>Submitted On:</p>
                                <p>{Helper.formatDateTime(practiceassignment?.assignment_completed_at).date}</p>
                            </>
                        )}
                    </div>
                </div>
                {practiceassignment?.submission === null ?
                    <button
                        className="maltiple-assignment-btn maltiple-assignment-start-assignment-btn"
                        disabled={practiceassignment?.assignment_json === null || practiceassignment?.ai_feedback_json === null}
                        title={practiceassignment?.assignment_json === null || practiceassignment?.ai_feedback_json === null ? "Generating assignment...Please wait!" : ""}
                        onClick={() => startAssignmentPopup(practiceassignment?.rubric_id)}
                    >
                        {practiceassignment?.assignment_json === null || practiceassignment?.ai_feedback_json === null ? 'Generating assignment...Please wait!' : 'Start Assignment'}
                    </button>
                    : <button className="maltiple-assignment-btn maltiple-assignment-start-assignment-btn maltiple-assignment-view-result-assignment-btn" disabled={practiceassignment?.submission === null} onClick={() => { assignmentResultHandler(practiceassignment); setshowScorePopup(!showScorePopup) }}>View Result</button>
                }
            </div>

            {/* {pracassignmentPopUp && <MultipleAssignmentviewPopup type={"Review Assignment"} startAssignmentPopupHandler={() => setpracassignmentPopUp(!pracassignmentPopUp)} startAssignmentHandler={startPractiseAssignmentHandler} rubrics={null} assignment={practiceassignment} index={index} />} */}
            {pracassignmentPopUp && <MultipleAssignmentviewPopup type={"Practice Assignment"} startAssignmentPopupHandler={() => setpracassignmentPopUp(!pracassignmentPopUp)} startAssignmentHandler={startPractiseAssignmentHandler} rubric={mainRubric} assignment={practiceassignment} index={index} courseType={courseType} />}

            {showScorePopup && (
                <StudentAssignmentScore
                    showScore={() => { }}
                    getSubmissiondtls={practiceassignment?.submission?.ai_evaluation_json}
                    onclick={() => {
                        setshowScorePopup(!showScorePopup)
                    }}
                    title={"Close"}
                    isCurrentAssignment={true}
                    onclick2={() => {
                        setdetailedResult(!detailedResult)
                        setshowScorePopup(!showScorePopup)
                    }}
                    title2={"View Result"}
                    // title3={"Review Assignment"}
                    title3={"Practice Assignment"}
                    assignment={practiceassignment}
                    setshowScorePopup={setshowScorePopup}
                    setShowCongratulations={setShowCongratulations}
                    setcallWebSocket={setcallWebSocket}
                    callWebSocket={callWebSocket}
                    setwebsocketPayload={setwebsocketPayload}
                    isNaviget={false}
                    filteredAssignments={filteredAssignments}
                    submission_Id={practiceassignment?.submission?.submission_id}
                />
            )}

            {showCongratulations && <CongratulationsPopup
                check_image={check_image}
                des="Assignment is being generated, please wait..."
            />}

            {detailedResult && (
                <div className="AssignmentViewProgress-mock-test-wrapper">
                    <div
                        className="AssignmentViewProgress-mock-test-container max-h-[90vh] overflow-y-auto"
                    >
                        {
                            <QuestionNew
                                assignment={
                                    practiceassignment?.submission?.student_answers_json[
                                    assignmentIndex
                                    ]
                                }
                                ai_evaluation_json={
                                    practiceassignment?.submission?.ai_evaluation_json
                                }
                                index={assignmentIndex}
                                arrayIndex={arrayIndex}
                                currentStep={assignmentIndex + 1}
                                totalSteps={
                                    practiceassignment?.submission?.student_answers_json.length
                                }
                                handleNext={() =>
                                    assignmentIndex <
                                        practiceassignment?.submission?.student_answers_json.length - 1
                                        ? setAssignmentIndex((p) => p + 1)
                                        : null
                                }
                                handleBack={() => setAssignmentIndex((p) => p - 1)}
                                isLast={
                                    assignmentIndex ===
                                    practiceassignment?.submission?.student_answers_json.length - 1
                                }
                                isFirst={assignmentIndex === 0}
                                close={
                                    <span
                                        onClick={() => {
                                            setdetailedResult(!detailedResult)
                                            setAssignmentIndex(0)
                                        }}
                                        className="AssignmentViewProgress-mock-test-close-btn"
                                    >
                                        <i className="fa-solid fa-x"></i>
                                    </span>
                                }
                                questions={practiceassignment?.submission?.ai_evaluation_json?.questions}
                                assignmentType={practiceassignment?.assignment_type}
                                courseType={courseType}
                                currentAssignment={assignmentJSON[assignmentIndex]}
                            />
                        }
                    </div>
                </div>
            )}

        </>
    );
}

export default MultipleAssignmentStartAssignment;
